<template>
  <dara-form v-slot="{ validate }" :submit="validateUser">
    <dara-row>
      <dara-col
        class="text-center mb-3"
        :sm="12">
        <dara-input
          v-model="info.first_name"
          type="text"
          :name="$t('first-name-field')"
          rules="required"
          :placeholder="$t('first-name') + '*'"
          :focus="true" />
      </dara-col>
      <dara-col
        class="text-center mb-3"
        :sm="12">
        <dara-input
          v-model="info.last_name"
          :name="$t('last-name-field')"
          type="text"
          rules="required"
          :placeholder="$t('last-name') + '*'" />
      </dara-col>
    </dara-row>
    <dara-row>
      <dara-col
        class="text-center mb-3">
        <dara-input
          v-model="info.email"
          type="email"
          :name="$t('email-field')"
          rules="required|email"
          :placeholder="$t('email') + '*'" />
      </dara-col>
    </dara-row>
    <dara-row>
      <dara-col
        class="text-center mb-3"
        :sm="12">
        <dara-input
          v-model="info.password"
          :name="$t('password-field')"
          type="password"
          rules="required|min:8"
          :placeholder="$t('password') + '*'" />
      </dara-col>
      <dara-col
        class="text-center mb-3"
        :sm="12">
        <dara-input
          v-model="info.confirm_password"
          :name="$t('confirm-password-field')"
          type="password"
          rules="required|min:8"
          :placeholder="$t('confirm-password') + '*'" />
      </dara-col>
    </dara-row>
    <dara-row>
      <dara-col class="text-center mb-3" :sm="24" :offset="0">
        <dara-p v-if="error" color="danger">{{ error }}</dara-p>
      </dara-col>
    </dara-row>
    <dara-row>
      <dara-col
        class="text-center mb-3">
        <dara-button
          native-type="submit"
          class="btn btn-dark"
          @click="validate">
          {{ $t('next-step') }}
        </dara-button>
      </dara-col>
    </dara-row>
  </dara-form>
</template>

<script>

import { translate } from '@/services/translate.service';

export default {
  name: 'DaraUserRegisterInformation',
  inject: ['infoRegisterVm'],
  props: {
    language: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      error: null,
      info: this.infoRegisterVm.info,
    };
  },
  methods: {
    validateUser() {
      this.error = null;

      const specialChars = !!(this.info.password.match(/[`!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~]+/) && this.info.password.match(/\d+/));

      if (!specialChars) {
        this.error = `${translate('password-must-have-special-chars-and-numbers')}`;
      } else if (this.info.password !== this.info.confirm_password) {
        this.error = `${translate('passwords-doesnt-match')}`;
      } else {
        this.$emit('next');
      }
      setTimeout(() => {
        this.error = null;
      }, 5000);
    },
  },
};
</script>
